import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ResultsService } from 'src/app/core/services/results/results.service';
import { loadResults, setResults } from './results.actions';

@Injectable()
export class ResultsEffects {
  loadResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadResults),
      switchMap(() => this.resultsService.fetch()),
      map((results) => setResults({ results }))
    )
  );

  constructor(
    private actions$: Actions,
    private resultsService: ResultsService
  ) {}
}
